import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { map } from "lodash";
import { DataTable } from "@life-line-lab/components-react";
import { Col, Divider, Row } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import useQuery from "Hooks/query.hook";
import { routeToBoxesView } from "Helpers/index";
import { routeToOrderView } from "Helpers/route-order-view";

interface TrolleyViewProps {
  info?: any;
}

interface TrolleyHeaderProps {
  info: any;
  onBack: () => void;
}

const TrolleyHeader: React.FC<TrolleyHeaderProps> = ({ info, onBack }) => (
  <>
    <Col flex="none">
      <h3>{info.trolleyCode}</h3>
    </Col>
    <Col flex="none">
      <h3>
        <span className={`status ${info.status}`}>
          {info.status?.replaceAll("_", " ") || ""}
        </span>
      </h3>
    </Col>
    <Col flex="auto"></Col>
    <Col flex="none">
      {" "}
      <CloseCircleOutlined
        onClick={() => {
          onBack();
        }}
        className="cursor-pointer back-action right"
        style={{ fontSize: "20px" }}
      />
    </Col>
  </>
);

const ParcelTrackingTrolleyViewComponent: React.FC<TrolleyViewProps> = ({
  info,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const query = useQuery();

  const onBack = () => {
    const redirect: string | undefined = query.get("redirect") || undefined;
    const previousUrl: string | undefined = query.get("from") || undefined;
    previousUrl && !redirect
      ? history.push(decodeURIComponent(previousUrl))
      : history.goBack();
  };

  const handleOpenBoxesTrackingView = (boxID: string) => {
    const params = "redirect=trolley";
    routeToBoxesView(boxID, location, history, params);
  };

  const handleOrderView = (orderID) => {
    const params = "module=delivery&tabKey=3&subTab=1";
    routeToOrderView(orderID, location, history, params);
  };

  const columns: any = [
    {
      title:
        t("label.boxes").toLocaleUpperCase() +
        ` (${info?.boxParcelList?.length ?? 0})`,
      dataIndex: "boxParcelData",
      width: 60,
      ellipsis: true,
      render: (boxParcelData: any) => {
        return map(boxParcelData, (boxParcel) => {
          if (!boxParcel.parcelList || boxParcel.parcelList.length === 0)
            return (
              <span>
                {boxParcel?.boxCode}
                <br />
              </span>
            );
          return (
            <React.Fragment>
              <a
                className="clickable-id"
                onClick={(e: React.MouseEvent<HTMLElement>) => {
                  e.stopPropagation();
                  handleOpenBoxesTrackingView(boxParcel._id);
                }}
              >
                {boxParcel?.boxCode +
                  " - " +
                  boxParcel.parcelList.length +
                  " Parcels" || <span>""</span>}
                <br />
              </a>
            </React.Fragment>
          );
        });
      },
    },
    {
      title:
        t("label.bulk").toLocaleUpperCase() +
        ` (${info?.bulkParcelList?.length ?? 0})`,
      dataIndex: "bulkParcelList",
      width: 75,
      ellipsis: true,
      render: (bulkParcelList: any) => {
        return map(bulkParcelList, (bulkParcel) => {
          return (
            <React.Fragment>
              <a
                className="clickable-id"
                onClick={(e: React.MouseEvent<HTMLElement>) => {
                  e.stopPropagation();
                  handleOrderView(bulkParcel._id);
                }}
              >
                {bulkParcel?.trackingNumber || <span>""</span>}
                <br />
              </a>
            </React.Fragment>
          );
        });
      },
    },
    {
      title:
        t("label.loose").toLocaleUpperCase() +
        ` (${info?.looseParcelList?.length ?? 0})`,
      dataIndex: "looseParcelList",
      width: 70,
      ellipsis: true,
      render: (looseParcelList: any) => {
        return map(looseParcelList, (looseParcel) => {
          return (
            <React.Fragment>
              <a
                className="clickable-id"
                onClick={(e: React.MouseEvent<HTMLElement>) => {
                  e.stopPropagation();
                  handleOrderView(looseParcel._id);
                }}
              >
                {looseParcel?.trackingNumber || <span>""</span>}
                <br />
              </a>
            </React.Fragment>
          );
        });
      },
    },
  ];

  return (
    <>
      <div className="p-20 my-20 parcel-tracking-view status-selector">
        <div className="main-header"></div>
        <Row className="header" gutter={[16, 16]} align="bottom">
          <TrolleyHeader info={info} onBack={onBack} />
        </Row>
        <Divider />
        <Row gutter={[16, 16]} className="p-30 mt-30 details-container">
          <Col flex="auto">
            <DataTable rowKey="_id" columns={columns} dataSource={[info]} />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ParcelTrackingTrolleyViewComponent;
